<template>
<div class="mainContainer" :style="loginImage">
    <TopHeader :pageTitle="pageHead" />
    <!----------------Main Page------------------------------------------>
    <div class="pageContainer shadow-lg rounded" fluid="sm">
        <div class="page-content">
            <SecondaryHeader />

            <!------------Content Area-------------->
            <DbTiles />
            
        </div>
    </div>
</div>
</template>

<script>
// @ is an alias to /src
//Import Components
import TopHeader from "@/components/BaseFiles/TopHeader.vue";
import SecondaryHeader from "@/components/BaseFiles/SecondHeader.vue";

import DbTiles from "@/components/Home/dbTiles.vue";

// Import Images
import bgImage from "@/assets/img/dbTiles/BG.png";

export default {
    name: "Dashboard",
    components: {
        TopHeader,
        SecondaryHeader,
        DbTiles
    },
    data() {
        return {
            loginImage: {
                backgroundImage: "url(" + bgImage + ")"
            },
            pageHead: "Dashboard",
            username: null
        };
    }
};
</script>
